module.exports = __webpack_public_path__ + "static/media/holdedge.74d8b0e8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/holdedge.mp3
// module id = 511
// module chunks = 0